var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "45px",
    height: "30px",
    viewBox: "0 0 67 106",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6 53.52C66.6 62.72 63.35 70.57 56.85 77.07C50.35 83.57 42.5 86.82 33.3 86.82C24.1 86.82 16.25 83.57 9.75 77.07C3.25 70.57 0 62.72 0 53.52C0 44.32 3.25 36.47 9.75 29.97C16.25 23.47 24.1 20.22 33.3 20.22C42.5 20.22 50.35 23.47 56.85 29.97C63.35 36.47 66.6 44.32 66.6 53.52ZM33.3 29.73C26.72 29.73 21.11 32.05 16.47 36.69C11.83 41.33 9.51 46.94 9.51 53.52C9.51 60.1 11.83 65.71 16.47 70.35C21.11 74.99 26.72 77.31 33.3 77.31C39.88 77.31 45.49 74.99 50.13 70.35C54.77 65.71 57.09 60.1 57.09 53.52C57.09 46.94 54.77 41.33 50.13 36.69C45.49 32.05 39.88 29.73 33.3 29.73Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.85 96.34C63.16 96.34 64.28 96.81 65.21 97.74C66.14 98.67 66.61 99.79 66.61 101.1C66.61 102.41 66.14 103.53 65.21 104.46C64.28 105.39 63.16 105.86 61.85 105.86H4.76C3.45 105.86 2.33 105.39 1.4 104.46C0.47 103.53 0 102.41 0 101.1C0 99.79 0.47 98.67 1.4 97.74C2.33 96.81 3.45 96.34 4.76 96.34H61.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmni);
export default __webpack_public_path__ + "static/media/omni.3a69760740467666d02cec12a5f49d2b.svg";
export { ForwardRef as ReactComponent };